import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";


type Props = {
    onActionEdit: (idClienteCentroCusto: number | null, openState: boolean) => void,
    onActionDelete: (idClienteCentroCusto: number | null, openState: boolean) => void,
}

export const GenerateClientesCentroCustoListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {
    const computeStatusTitle = (status: boolean) => {
        switch (status) {
            case false:
                return "Não";
            case true:
                return "Sim";
            default:
                return "?";
        }
    };

    const computeStatusColor = (status: boolean) => {
        switch (status) {
            case false:
                return "red";
            case true:
                return "green";
            default:
                return "blue";
        }
    };

    const computeStatusDescription = (status: boolean) => {
        switch (status) {
            case false:
                return "Não Principal";
            case true:
                return "Sim Principal";
            default:
                return "?";
        }
    };


    return [
        {
            field: "principal",
            filterable: false,
            headerName: "Principal",
            minWidth: 80,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeStatusTitle(params.value ? true : false)}
                        color={computeStatusColor(params.value ? true : false)}
                        description={computeStatusDescription(params.value ? true : false)} />
                </div>
            )
        },
        {
            field: "centroCustoCodigo",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "unidade",
            filterable: false,
            headerName: "Unidade",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },

        {
            field: 'idClienteCentroCusto',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}